// BonBoZ: bo dau tieng Viet de tim kiem khop ca "tuyen" lan "Tuyển".
//
// NFD tach nguyen am ra thanh chu goc + dau roi xoa dai dau ket hop, nhung
// 'đ'/'Đ' (U+0111/U+0110) la mot ky tu rieng, KHONG bi NFD tach - phai thay
// tay, neu khong "đơn hàng" van khong khop "don hang".
export const boDau = (text = '') =>
  String(text ?? '')
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/\u0111/g, 'd')
    .replace(/\u0110/g, 'D');

export default boDau;
